import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

import images from '../../../helpers/images';
import appConfig from '../../../config/env';
import store from '../../../helpers/store';
import DropDownSelection from '../../elements/DropDownSelection';
import InputText from '../../elements/InputText';
import InputTextArea from '../../elements/InputTextArea';
import InputNumber from '../../elements/InputNumber';
import RenderErrors from '../../elements/RenderErrors';
import { httpRequest } from '../../../helpers/httpService';
import Loader from '../../parts/Loader';
import Swal from 'sweetalert2';
 
function UserProfile (){
    const api_url = appConfig.apiUrl;
    const url = api_url + '/client/profile';
    const [profile_data, setProfile] = useState(store.profile_data);
    const [errors, setErrors] = useState([]);
    const [loading, setLoading] = useState(0);

    useEffect(() => {
        getProfileData()
    }, []);

    function getProfileData() {

        setLoading(1)

        httpRequest(url, "GET", '', true)
            .then((res) => {
                const obj = store.countries.find(o => o.code === res.country);
                
                if(obj === undefined){
                    res.country = ''
                }

                setProfile(res);
                setLoading(0)
            })
            .catch((err) => {
                setLoading(0)
                
                //Unauthorize
                if(err.status_code === 401){
                    window.location.href = "/";
                }

                Swal.fire({
                    title: "Error!",
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                    allowOutsideClick: false,
                });
            });
    }

    function inputChange(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;
            } else {
                value = 0;
            }
        }

        let new_state = { [name]: value }

        setProfile({ ...profile_data, ...new_state });
    }

    function removeErrors(e){
        let { name } = e.target;
        let newErrors = {...errors}

        delete newErrors[name];

        setErrors(newErrors);
    }

    function submit(){
        setLoading(1)
        httpRequest(url, "POST", 
            { 
                postdata: { 
                    ...profile_data, 
                }
            }
        , true)
        .then((res) => {
            setLoading(0)

            if(res.message){
  
                Swal.fire({
                    title: 'Success!',
                    text: res.message,
                    icon: 'success',
                    confirmButtonText: 'OK'
                });

            }
        })
        .catch((err) => {
            setLoading(0);
  
            if(err.data){
                setErrors( err.data );
                err.message = "Please check your entry";
  
                // if(err.data.captcha){
                //     err.message = err.data.captcha[0];
                // }
            }else{
              setErrors([])
            }
  
            Swal.fire({
                title: 'Error!',
                text: err.message,
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }); 
    }

    return (
        <section className="faith">
        <div className="container">
            <div className="parent">
            <div className="container">
                <div className="row">
                <div className="col-md-12 mt-5 mb-5">
                    <h1>User Profile</h1>
                    
                    <p>This data are used to auto fill in the event registration form.< br/>Required fields <span className='text-danger'>*</span></p>

                    <div className="row mt-5" style={{position: 'relative'}}>
                        <Loader isLoading={loading}/>

                        <div className="col-sm-12 col-lg-6 px-4">

                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className='fs-6' htmlFor="first_name">Partner ID</label>
                                </div>
                                <div className="col-6 col-sm-4 col-md-3">
                                        <div className="form-group">
                                            <div className="input-group">
                                                <InputText
                                                    id="first_name" 
                                                    name="first_name" 
                                                    value={profile_data.partner_id ?? 'N/A'}    
                                                    tagClass="form-control mb-0"
                                                    onChange={inputChange}
                                                    placeholder="Your First Name"
                                                    onFocus={removeErrors}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className='fs-6' htmlFor="email">Email</label>
                                </div>
                                <div className="col-lg-8">
                                        <div className="form-group">
                                            <div className="input-group">
                                                <InputText
                                                    id="email" 
                                                    name="email" 
                                                    value={profile_data.email}    
                                                    tagClass="form-control mb-0"
                                                    onChange={inputChange}
                                                    placeholder="Email Address"
                                                    onFocus={removeErrors}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className='fs-6' htmlFor="first_name">First Name<span className='text-danger'>*</span></label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <InputText
                                                id="first_name" 
                                                name="first_name" 
                                                value={profile_data.first_name}    
                                                tagClass="form-control mb-0"
                                                onChange={inputChange}
                                                placeholder="Your First Name"
                                                onFocus={removeErrors}
                                            />


                                            <div className="input-group-addon">
                                                <img src={images.editIcon} className="edit-icon" /><span className="edit-text">Edit</span>
                                            </div>
                                        </div>
                                    </div>
                                    <RenderErrors 
                                        errors={errors} 
                                        name="first_name"
                                        className="text-danger fs-7"
                                    />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className='fs-6' htmlFor="last_name">Last Name<span className='text-danger'>*</span></label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <InputText
                                                id="last_name" 
                                                name="last_name" 
                                                value={profile_data.last_name}    
                                                tagClass="form-control mb-0"
                                                onChange={inputChange}
                                                placeholder="Your Last Name"
                                                onFocus={removeErrors}
                                            />
                                            <div className="input-group-addon">
                                                <img src={images.editIcon} className="edit-icon" /><span className="edit-text">Edit</span>
                                            </div>
                                        </div>
                                    </div>
                                    <RenderErrors 
                                        errors={errors} 
                                        name="last_name" 
                                        className="text-danger fs-7"
                                    />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className='fs-6' htmlFor="middle_name">Middle Name/Initial</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <InputText
                                                id="middle_name" 
                                                name="middle_name" 
                                                value={profile_data.middle_name}    
                                                tagClass="form-control mb-0"
                                                onChange={inputChange}
                                                placeholder="Your Middle Name/Initial (optional)"
                                                onFocus={removeErrors}
                                            />


                                            <div className="input-group-addon">
                                                <img src={images.editIcon} className="edit-icon" /><span className="edit-text">Edit</span>
                                            </div>
                                        </div>
                                    </div>
                                    <RenderErrors 
                                        errors={errors} 
                                        name="middle_name" 
                                        className="text-danger fs-7"
                                    />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className='fs-6' htmlFor="birth_date">Gender<span className='text-danger'>*</span></label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <DropDownSelection
                                                tagClass="form-control mb-0"
                                                name="gender"
                                                placeholder="Select Gender" 
                                                value={profile_data.gender}  
                                                onChange={inputChange}
                                                onFocus={removeErrors}
                                                optionList={store.gender}
                                                optionProps ={{value:'id', label:'label'}}
                                            />
                                            <div className="input-group-addon">
                                                <img src={images.editIcon} className="edit-icon" /><span className="edit-text">Edit</span>
                                            </div>
                                        </div>
                                    </div>
                                    <RenderErrors 
                                        errors={errors} 
                                        name="gender" 
                                        className="text-danger fs-7"
                                    />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className='fs-6' htmlFor="mobile_no">Mobile<span className='text-danger'>*</span></label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <InputText
                                                id="mobile_no" 
                                                name="mobile_no" 
                                                value={profile_data.mobile_no}    
                                                tagClass="form-control mb-0"
                                                onChange={inputChange}
                                                placeholder="Your Mobile Number"
                                                onFocus={removeErrors}
                                            />
                                            <div className="input-group-addon">
                                                <img src={images.editIcon} className="edit-icon" /><span className="edit-text">Edit</span>
                                            </div>
                                        </div>
                                    </div>
                                    <RenderErrors 
                                        errors={errors} 
                                        name="mobile_no"
                                        className="text-danger fs-7"
                                    />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className='fs-6' htmlFor="birth_date">Birth Date</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <InputText
                                                id="birth_date" 
                                                name="birth_date" 
                                                value={profile_data.birth_date}    
                                                tagClass="form-control mb-0"
                                                onChange={inputChange}
                                                placeholder="Your Birth Date"
                                                onFocus={removeErrors}
                                                type="date"
                                            />
                                            <div className="input-group-addon">
                                                <img src={images.editIcon} className="edit-icon" /><span className="edit-text">Edit</span>
                                            </div>
                                        </div>
                                    </div>
                                    <RenderErrors 
                                        errors={errors} 
                                        name="birth_date"
                                        className="text-danger fs-7"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='col-sm-12 col-lg-6 px-4'>

                                <div className="row mb-3">
                                    <div className="col-lg-4">
                                        <label className='fs-6' htmlFor="address1">Address 1</label>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="form-group">
                                            <div className="input-group">
                                                <InputTextArea
                                                    id="address1" 
                                                    name="address1" 
                                                    value={profile_data.address1}    
                                                    tagClass="form-control mb-0"
                                                    onChange={inputChange}
                                                    placeholder="Your Address 1"
                                                    onFocus={removeErrors}
                                                />
                                                <div className="input-group-addon">
                                                    <img src={images.editIcon} className="edit-icon" /><span className="edit-text">Edit</span>
                                                </div>
                                            </div>
                                        </div>
                                        <RenderErrors 
                                            errors={errors} 
                                            name="address1" 
                                            className="text-danger fs-7"
                                        />
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-lg-4">
                                        <label className='fs-6' htmlFor="address2">Address 2</label>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="form-group">
                                            <div className="input-group">
                                                <InputTextArea
                                                    id="address2" 
                                                    name="address2" 
                                                    value={profile_data.address2}    
                                                    tagClass="form-control mb-0"
                                                    onChange={inputChange}
                                                    placeholder="Your Address 2"
                                                    onFocus={removeErrors}
                                                />
                                                <div className="input-group-addon">
                                                    <img src={images.editIcon} className="edit-icon" /><span className="edit-text">Edit</span>
                                                </div>
                                            </div>
                                        </div>
                                        <RenderErrors 
                                            errors={errors} 
                                            name="address2" 
                                            className="text-danger fs-7"
                                        />
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-lg-4">
                                        <label className='fs-6' htmlFor="city">City</label>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="form-group">
                                            <div className="input-group">
                                                <InputText
                                                    id="city" 
                                                    name="city" 
                                                    value={profile_data.city}    
                                                    tagClass="form-control mb-0"
                                                    onChange={inputChange}
                                                    placeholder="Your City"
                                                    onFocus={removeErrors}
                                                />
                                                <div className="input-group-addon">
                                                    <img src={images.editIcon} className="edit-icon" /><span className="edit-text">Edit</span>
                                                </div>
                                            </div>
                                        </div>
                                        <RenderErrors 
                                            errors={errors} 
                                            name="city"
                                            className="text-danger fs-7"
                                        />
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-lg-4">
                                        <label className='fs-6' htmlFor="state">State/Province</label>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="form-group">
                                            <div className="input-group">
                                                <InputText
                                                    id="state" 
                                                    name="state" 
                                                    value={profile_data.state}    
                                                    tagClass="form-control mb-0"
                                                    onChange={inputChange}
                                                    placeholder="Your State/Province"
                                                    onFocus={removeErrors}
                                                />
                                                <div className="input-group-addon">
                                                    <img src={images.editIcon} className="edit-icon" /><span className="edit-text">Edit</span>
                                                </div>
                                            </div>
                                        </div>
                                        <RenderErrors 
                                            errors={errors} 
                                            name="state" 
                                            className="text-danger fs-7"
                                        />
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-lg-4">
                                        <label className='fs-6' htmlFor="country">Country</label>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="form-group">
                                            <div className="input-group">
                                                <DropDownSelection
                                                    tagClass="form-control mb-0"
                                                    name="country"
                                                    placeholder="Select Country" 
                                                    value={profile_data.country}  
                                                    onChange={inputChange}
                                                    onFocus={removeErrors}
                                                    optionList={store.countries}
                                                    optionProps ={{value:'code', label:'name'}}
                                                />
                                                <div className="input-group-addon">
                                                    <img src={images.editIcon} className="edit-icon" /><span className="edit-text">Edit</span>
                                                </div>
                                            </div>
                                        </div>
                                        <RenderErrors 
                                            errors={errors} 
                                            name="country"
                                            className="text-danger fs-7"
                                        />
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-lg-4">
                                        <label className='fs-6' htmlFor="postal_code">Postal Code</label>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="form-group">
                                            <div className="input-group">
                                                <InputNumber
                                                    id="postal_code" 
                                                    name="postal_code" 
                                                    value={profile_data.postal_code}    
                                                    tagClass="form-control mb-0"
                                                    onChange={inputChange}
                                                    placeholder="Your Postal Code"
                                                    onFocus={removeErrors}
                                                />
                                                <div className="input-group-addon">
                                                    <img src={images.editIcon} className="edit-icon" /><span className="edit-text">Edit</span>
                                                </div>
                                            </div>
                                        </div>
                                        <RenderErrors 
                                            errors={errors} 
                                            name="postal_code"
                                            className="text-danger fs-7"
                                        />
                                    </div>
                                </div>
                        </div>

                        <div className="col-12">
                            <button className="btn btn-user-profile" onClick={submit}>Save</button>
                        </div>
                    </div>

                </div>
                </div>
            </div>
            {/* End Login navigation  */}
            </div>
        </div>
        </section>


    )
}
 
export default UserProfile;